import $ from 'jquery'
import {setSameHeight, initSlides, generateProductHTML, initSwiper, handleClickProductCatTypeMenuItem} from '../abstracts/utils'

export default () => {
  $(() => {
    if (!$('body').hasClass('page-template-home')) return

    let $sectionMasthead = $('.section-masthead')
    if ($sectionMasthead.length) {
      initSlides($sectionMasthead.find('.slideshow:not(.slick-initialized.slick-slider)'), 1, true, true, [], false)
      setHeightSlide($sectionMasthead)
    }

    let $sectionSubMenu = $('.section-sub-menu')
    if ($sectionSubMenu.length) {
      initSwiper($sectionSubMenu.find('.swiper-container').get(), 4, true, false, {})
      $sectionSubMenu.find('.menu-item').click(e => {
        e.preventDefault()
        handleClickProductCatTypeMenuItem(e)
      })
    }

    // let $sectionBrands = $('.section-brands')
    // if ($sectionBrands.length) {
    //   initSlides($sectionBrands.find('.slideshow:not(.slick-initialized.slick-slider)'), 8, true, false, [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 3
    //       }
    //     },
    //     {
    //       breakpoint: 992,
    //       settings: {
    //         slidesToShow: 5
    //       }
    //     }
    //   ], null, false)
    // }

    let $sectionProducts = $('.section-products')
    if ($sectionProducts.length) {
      initSlides($sectionProducts.find('.slideshow:not(.slick-initialized.slick-slider)'), 5, true, false, [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ], null)

      $sectionProducts.find('.product-mode').click(e => {
        if (! $(e.target).hasClass('active')) {
          // remove current active
          $(e.target).parent().children('.product-mode').removeClass('active')
          $sectionProducts.find('.slideshow').removeClass('active')
          // add active
          $(e.target).addClass('active')
          $sectionProducts.find('#' + $(e.target).data('target')).addClass('active').slick('refresh')
        }
      })
    }

    let $sectionProductCats = $('.section-product_cats-listing')
    if ($sectionProductCats.length) {
      $sectionProductCats.each(function(index, item) {
        setSameHeight($(item).find('.products.mobile .product__content'))

        if ($(item).find('.titles .term-children .slideshow').children().length > 5)
          initSlides($(item).find('.titles .term-children .slideshow'), 5, true, false, [], {
            variableWidth: true
          }, false)

        initSlides($(item).find('.products.slideshow:not(.slick-initialized.slick-slider)'), 5, true, false, [], null)
      })
    }

    $('.load-more-cta a').on('click', function(e) {
      let nextPage = $(e.target).attr('current-page')? parseInt($(e.target).attr('current-page')) + 1 : 1
      $.get(window.endpoint + '/get-product-cats-listing', {
        'page': nextPage
      })
        .done(res => {
          // console.log(res)
          let data = JSON.parse(res)
          // console.log(data)
          let index = $sectionProductCats.length

          for (let i = 0; i <= data.product_cats.length - 1; i++) {
            $('.load-more-cta').before(generateProductCatListingHTML(data.product_cats[i], index))
            setSameHeight($('.section-product_cats-listing[index="' + index + '"] .products.mobile .product__content'))

            if ($('.section-product_cats-listing[index="' + index + '"] .titles .term-children .slideshow').children().length > 5)
              initSlides($('.section-product_cats-listing[index="' + index + '"] .titles .term-children .slideshow'), 5, true, false, [], {
                variableWidth: true
              }, false)

            initSlides($('.section-product_cats-listing[index="' + index + '"] .products.slideshow:not(.slick-initialized.slick-slider)'), 5, true, false, [], null)
            index++
          }

          $(e.target).attr('current-page', nextPage)
          if (nextPage >= data.max_num_pages) $('.load-more-cta').hide()
        })
        .fail(err => {
          console.log(err)
        })
    })

    let $sectionClients = $('.section-clients')
    if ($sectionClients.length) {
      initSlides($sectionClients.find('.slideshow:not(.slick-initialized.slick-slider)'), 6, true, false, [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4
          }
        }
      ], {
        variableWidth: true
      })
    }
  })
}

function setHeightSlide($sectionMasthead) {
  if ($(window).width() < 992) return   // return when screen < 992px

  let $headerStatic = $('header.site-header.static')
  let $subMenuLv2 = $headerStatic.find('.nav-bar .main-navigation > .menu-header-desktop-container > ul.menu > li:first-child > .sub-menu')
  $sectionMasthead.find('.slide__inner').css('height', $subMenuLv2.height())    // sub menu lv2 (left sidebar) height
}

function generateProductCatListingHTML(data, index) {
  let html = ""
  html += `<section class="section-product_cats-listing" index="${index}"><div class="container">`

  html += `<div class="titles">`
  html += `<div class="headline text-center cl--white text-upper bg--elephant"><h3>${data.selected_product_cat.name}</h3></div>`
  html += `<div class="term-children hide@xs hide@sm hide@md"><div class="slideshow">`
  for (let i = 0; i < data.selected_product_cat.children.length; i++) {
    html += `<div class="slide__inner"><a href="${data.selected_product_cat.children[i].url}" term-id="${data.selected_product_cat.children[i].term_id}">${data.selected_product_cat.children[i].name}</a></div>`
  }
  html += `</div></div>`
  html += `<div class="see-all text-center hide@xs hide@sm"><a class="" href="${data.selected_product_cat.url}" term-id="${data.selected_product_cat.term_id}">Xem tất cả</a></div>`
  html += `</div>`

  html += `<div class="products products-columns-2 mobile hide@md hide@lg hide@xl">`
  for (let i = 0; i < data.products.length; i++) {
    html += generateProductHTML(data.products[i])
  }
  html += `</div>`

  html += `<div class="products slideshow hide@xs hide@sm">`
  for (let i = 0; i < data.products.length; i++) {
    html += generateProductHTML(data.products[i])
    // html += `<div class="product" product-id="${data.products[i].ID}"><div class="product__inner">`
    // html += `<div class="product__thumbnail" style="background-image: url('${data.products[i].thumbnail}')">`
    // html += `<a href="${data.products[i].url}"></a>`
    // if (data.products[i].discount != 0) {
    //   html += `<span class="badge badge-discount">-${data.products[i].discount}%</span>`
    // }
    // html += `</div>`
    // html += `<div class="product__content">`
    // html += `<p class="product__title">${data.products[i].title}</p>`
    // if (data.products[i].type === 'price') {    // show price
    //   if (data.products[i].discount != 0) {    // product has a discount
    //     html += `<a class="product__link" href="${data.products[i].url}">${numberFormat(data.products[i].actual_price)}đ</a>`
    //     html += `<a class="product__link price-disabled" href="${data.products[i].url}">${numberFormat(data.products[i].price)}đ</a>`
    //   } else {    // product doesn't have any discount
    //     html += `<a class="product__link" href="${data.products[i].url}">${numberFormat(data.products[i].price)}đ</a>`
    //   }
    // } else {    // show normal btn
    //   html += `<a class="product__link" href="${data.products[i].url}">Xem giá</a>`
    // }
    //
    // html += `</div>`
    // html +=  `</div></div>`
  }
  html += `</div>`

  html += `<div class="see-all text-center hide@md hide@lg hide@xl"><a class="" href="${data.selected_product_cat.url}" term-id="${data.selected_product_cat.term_id}">Xem tất cả</a></div>`

  html += `</div></section>`
  return html
}
